<template>
  <async-component v-if="$store.state.isShowPage">
    <router-view/>
  </async-component>
  <axiosLoading/>
  <vipDialog v-if="$store.state.vipDialog"/>
</template>

<script>
import { getJssdkConfig, getMemberfo, getUserInfo } from '@/api/apis';
import axiosLoading from '@/components/Loading.vue';
import vipDialog from '@/components/vipDialog.vue';
import MobileDetect from 'mobile-detect';
import wx from 'weixin-js-sdk';
export default {
  components: {
    axiosLoading,
    vipDialog
  },
  data () {
    return {
    };
  },
  created () {
    if (localStorage.getItem('themetype')) {
      this.$store.dispatch('changeStoreData', { key: 'themetype', value: localStorage.getItem('themetype') });
      this.getThemetype(localStorage.getItem('themetype'));
    }

    console.log(location.href.split('#')[0]);
    // document.getElementById('app').style.setProperty('--themeColor', 'red');
    // this.$store.state._this = this;
    // this.$cookies.set('WXUID', 'vcW5qGdTBzkwYjd2+PqG2t64SQtwy0XqxxZ7YQKSyzQ=');
    // this.$cookies.set('SUID', 'zSAnzKKQuLs9EYMWpn2OlV/I2uE/kwS84wDdoB7/pDI=');
    // 是否需要授权
    // const accessToken = this.$cookies.get('ACCESS_TOKEN');
    const md = new MobileDetect(window.navigator.userAgent);
    console.log('是否手机浏览器', md.mobile());
    if (md.mobile()) {
      sessionStorage.setItem('isPC', false);
    } else {
      sessionStorage.setItem('isPC', true);
    }
    // 是否是微信浏览器
    if (/(micromessenger)/i.test(navigator.userAgent)) {
      console.log('微信浏览器');
      sessionStorage.setItem('isWX', true);
      sessionStorage.setItem('isPC', false);
      const userAgent = navigator.userAgent.toLowerCase();
      if (userAgent.includes('micromessenger') && !/windows/i.test(userAgent) && /mobile/i.test(userAgent)) {
        sessionStorage.setItem('isinvoke', true);
      } else {
        sessionStorage.setItem('isinvoke', false);
      }
      let param = {
        url: window.location.href.split('#')[0],
        code: 'jxwh'
      };
      getJssdkConfig(param, this).then((res) => {
        console.log(res.appId, res.timestamp, res.nonceStr, res.signature);
        wx.config({
          debug: false,
          appId: res.appId,
          timestamp: res.timestamp,
          nonceStr: res.nonceStr,
          signature: res.signature,
          jsApiList: [
            'translateVoice',
            'startRecord',
            'onVoiceRecordEnd',
            'stopRecord',
            'uploadVoice',
            'downloadVoice',
            'playVoice',
            'pauseVoice',
            'stopVoice',
            'onVoicePlayEnd',
            'chooseImage',
            'uploadImage',
            'getLocalImgData',
            'downloadImage',
            'saveImageToPhotosAlbum',
            'chooseVideo',
            'uploadVideo',
            'chooseMessageFile',
            'launchMiniProgram',
            'updateAppMessageShareData', // 新版分享接口
            'updateTimelineShareData',
            'shareAppMessage',
            'getClipboardData',
            'requestMerchantTransfer'
          ],
          openTagList: ['wx-open-launch-weapp'] // 必须填写需要使用的开放标签
        });
        wx.ready(function () {
          console.log('进入ready');
        });
        wx.error(function (res) {
          // config信息验证失败会执行error函数，如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名。
          console.log('------ wx.error ------', res);
        });
      });
      // 判断是否为手机微信
      this.isWeChatOnMobile = userAgent.includes('micromessenger') && !/windows/i.test(userAgent) && /mobile/i.test(userAgent);
      // 判断是否为电脑版微信（网页版微信也会包含 micromessenger，但会在 Windows 平台下运行）
      this.isWeChatOnDesktop = userAgent.includes('micromessenger') && /windows/i.test(userAgent);
      console.log(this.isWeChatOnMobile, this.isWeChatOnDesktop);
    } else {
      console.log('其他浏览器');
      sessionStorage.setItem('isWX', false);
      sessionStorage.setItem('isPC', true);
    }
    if (this.$cookies.get('sessionId')) {
      if (sessionStorage.getItem('getUserInfo')) {
        this.$store.dispatch('changeStoreData', { key: 'getUserInfo', value: JSON.parse(sessionStorage.getItem('getUserInfo')) });
      } else {
        this.getUserInfo();
      }
      // if (sessionStorage.getItem('memberInfo')) {
      //   this.$store.dispatch('changeStoreData', { key: 'memberInfo', value: JSON.parse(sessionStorage.getItem('memberInfo')) });
      // } else {
      this.getUserInfoParam();
      // }
      this.$store.dispatch('changeStoreData', { key: 'sessionId', value: this.$cookies.get('sessionId') });
    } else {
      this.$store.dispatch('changeStoreData', { key: 'sessionId', value: '' });
    }
    // 禁止默认点击事件
    document.oncontextmenu = function (e) {
      // e.preventDefault();
    };
  },
  methods: {
    getUserInfo () {
      let getUserInfoParam = {
        sessionId: this.$cookies.get('sessionId')
      };
      getUserInfo(getUserInfoParam, this).then((res) => {
        sessionStorage.setItem('getUserInfo', JSON.stringify(res));
        this.$store.dispatch('changeStoreData', { key: 'getUserInfo', value: res });
      });
    },
    getUserInfoParam () {
      let getUserInfoParam = {
        sessionId: this.$cookies.get('sessionId')
      };
      getMemberfo(getUserInfoParam, this).then((res) => {
        sessionStorage.setItem('memberInfo', JSON.stringify(res));
        this.$store.dispatch('changeStoreData', { key: 'memberInfo', value: res });
        let theme = res.config.theme === 'dark' ? '深色' : '浅色';
        if (localStorage.getItem('themetype')) {
          if (localStorage.getItem('themetype') !== theme) {
            localStorage.setItem('themetype', theme);
            this.$store.dispatch('changeStoreData', { key: 'themetype', value: theme });
            this.getThemetype(theme);
          }
        } else {
          localStorage.setItem('themetype', theme);
          this.$store.dispatch('changeStoreData', { key: 'themetype', value: theme });
          this.getThemetype(theme);
        }
      });
    },
    getThemetype (item) {
      if (item === '深色') {
        document.getElementById('app').style.setProperty('--themeColor', '#141519');
        document.getElementById('app').style.setProperty('--backColor', '#141519');
        document.getElementById('app').style.setProperty('--msgColor', '#1F2024');
        document.getElementById('app').style.setProperty('--textColor', '#FFFFFF');
        document.getElementById('app').style.setProperty('--text_Color', '#fff');
        document.getElementById('app').style.setProperty('--topColor', '#141519');
        document.getElementById('app').style.setProperty('--vipColor', '#FFDDB2');
        document.getElementById('app').style.setProperty('--popupbottomColor', '#727378');
      } else {
        document.getElementById('app').style.setProperty('--themeColor', 'rgb(237,237,237)');
        document.getElementById('app').style.setProperty('--backColor', '#ffffff');
        document.getElementById('app').style.setProperty('--msgColor', '#fff');
        document.getElementById('app').style.setProperty('--textColor', '#1F2330');
        document.getElementById('app').style.setProperty('--text_Color', '#1F2024');
        document.getElementById('app').style.setProperty('--topColor', 'rgb(237,237,237)');
        document.getElementById('app').style.setProperty('--vipColor', '#e0ae6c');
        document.getElementById('app').style.setProperty('--popupbottomColor', '#c8c8ca');
      }
    }
  }
};
</script>
<style lang="less">
:root:root {
  --van-popover-action-width: 225px;
}
body{
  -webkit-touch-callout:none;/*系统默认菜单被禁用*/
  -webkit-user-select:none;/*webkit浏览器*/
  -khtml-user-select:none;/*早起浏览器*/
  -moz-user-select:none;/*火狐浏览器*/
  -ms-user-select:none;/*IE浏览器*/
  user-select:none;/*用户是否能够选中文本*/
}
*{
  margin: 0;
  padding: 0;
}
#app {
  --view-rotate-x: 0deg;
  --view-rotate-y: 0deg;
  --view-rotate-z: 0deg;
  --view-translate-x: 0%;
  --view-translate-y: 0%;
  --view-translate-z: 1;
  --themeColor:rgb(237,237,237);
  --backColor:#ffffff;
  --msgColor:#fff;
  --textColor:#1F2330;
  --text_Color:#1F2024;
  --topColor:rgb(237,237,237);
  --vipColor:#e0ae6c;
  --popupbottomColor:#c8c8ca;
  // --themeColor:#141519;
  // --backColor:#141519;
  // --msgColor:#1F2024;
  // --textColor:#FFFFFF;
  // --text_Color:#fff;
  // --topColor:#141519;
  // --vipColor:#FFDDB2;
  // --popupbottomColor:#727378;
  height: 100vh;
  // background-color: var(--themeColor);
  background-image: linear-gradient(149deg, #F5F8FC 0%, #EDF5FF 72%);
  font-family: PingFangSC-Regular, PingFang SC;
}
img{
  pointer-events:none;
}
</style>
